import { IExternalLinkConfig } from '@app/core/models/project-config.model';
import { StandardResponse } from '@app/core/models/standard-response.model';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig, APP_CONFIG } from '@app/app-config.module';
import { Observable } from 'rxjs';
import { timeout, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProjectConfigService {
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private http: HttpClient
  ) {}

  externalLinkConfig(): Observable<StandardResponse<IExternalLinkConfig>> {
    return this.http
      .post<StandardResponse<IExternalLinkConfig>>(
        `${this.config.apiEndpoint}/user-management/external-link`,
        {}
      )
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }
}
